import React from 'react';
import type { CellRenderProps } from '@axiom/ui';

import type { CandidateDetail } from '../../api/chat-api';
import { MatchGridUtil } from '../../utils/match-grid-util';

/**
 * A candidate's email address, as a link that starts a message to them.
 *
 * **A bare anchor rather than the router's `Link` or the design system's `Button`**: a `mailto:` is
 * not a path, so the router would read it as one, and a button is drawn as a button - grey, where
 * the name beside it is a link. This is the element the name cell ends up rendering, so the two
 * match without either of them saying what a link looks like.
 */
export const MatchGridTalentEmail = ({
  data,
}: CellRenderProps<CandidateDetail>) => {
  if (!data.email) return MatchGridUtil.NOT_YET;

  return (
    <a data-test={`TALENT_EMAIL_LINK_${data.id}`} href={`mailto:${data.email}`}>
      {data.email}
    </a>
  );
};
